import { RootState } from "@/store/types";
import { Module } from "vuex";
import { actions } from "./actions";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { StatisticState } from "./types";

export const state: StatisticState = {
  whatsappStatisticDetail: [],
  whatsappStatisticDetailFlag: undefined,
  whatsappStatisticGroup: [],
  // whatsappStatisticGroupMessageCount: 0,
  whatsappGroupings: {
    whatsappGroup: [
      'hour',
      'day',
      'week',
      'month',
    ],
    whatsappGroupByOptionally: [
      'partner',
      'service_provider',
      'originator',
      'template_id',
      'bulk_id',
      'broker_account_login',
      'message_type',
    ],
  },
};

export const whatsappStatistic: Module<StatisticState, RootState> = {
  state,
  actions,
  getters,
  mutations,
};
